import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {FeatureTaxDonationDetailsComponent} from "./tax-donation-details/feature-tax-donation-details.component";
import {AangeverComponent} from "./schenking/aangever/aangever.component";
import {AlgemeneVragenComponent} from "./schenking/algemene-vragen/algemene-vragen.component";
import {BelastingComponent} from "./schenking/belasting/belasting.component";
import {BerekeningComponent} from "./schenking/berekening/berekening.component";
import {ContactpersoonComponent} from "./schenking/contactpersoon/contactpersoon.component";
import {ContantenComponent} from "./schenking/contanten/contanten.component";
import {EffectenComponent} from "./schenking/effecten/effecten.component";
import {KwijtscheldingenComponent} from "./schenking/kwijtscheldingen/kwijtscheldingen.component";
import {OndernemingenComponent} from "./schenking/ondernemingen/ondernemingen.component";
import {OnroerendeZakenComponent} from "./schenking/onroerende-zaken/onroerende-zaken.component";
import {OverigeSchenkingenComponent} from "./schenking/overige-schenkingen/overige-schenkingen.component";
import {RoerendeZakenComponent} from "./schenking/roerende-zaken/roerende-zaken.component";
import {SchenkerComponent} from "./schenking/schenker/schenker.component";
import {SchuldigerkenningenComponent} from "./schenking/schuldigerkenningen/schuldigerkenningen.component";
import {UitkeringenComponent} from "./schenking/uitkeringen/uitkeringen.component";
import {VrijstellingenComponent} from "./schenking/vrijstellingen/vrijstellingen.component";
import {VruchtgebruikComponent} from "./schenking/vruchtgebruik/vruchtgebruik.component";
import {AkteComponent} from "./schenking/akte/akte.component";
import {ConserverendeAanslagComponent} from "./schenking/conserverende-aanslag/conserverende-aanslag.component";
import {VoorkomingComponent} from "./schenking/voorkoming/voorkoming.component";
import {BorComponent} from "./schenking/bor/bor.component";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {TekstAangeverComponent} from "./schenking/toelichtingen-tekst/tekst-aangever/tekst-aangever.component";
import {TekstSchenkerComponent} from "./schenking/toelichtingen-tekst/tekst-schenker/tekst-schenker.component";
import {
    TekstSchuldigerkenningenComponent
} from "./schenking/toelichtingen-tekst/tekst-schuldigerkenningen/tekst-schuldigerkenningen.component";
import {TekstUitkeringenComponent} from "./schenking/toelichtingen-tekst/tekst-uitkeringen/tekst-uitkeringen.component";
import {TekstVoorkomingComponent} from "./schenking/toelichtingen-tekst/tekst-voorkoming/tekst-voorkoming.component";
import {
    TekstVrijstellingenComponent
} from "./schenking/toelichtingen-tekst/tekst-vrijstellingen/tekst-vrijstellingen.component";
import {
    TekstVruchtgebruikComponent
} from "./schenking/toelichtingen-tekst/tekst-vruchtgebruik/tekst-vruchtgebruik.component";
import {
    TekstRoerendeZakenComponent
} from "./schenking/toelichtingen-tekst/tekst-roerende-zaken/tekst-roerende-zaken.component";
import {
    TekstOverigeSchenkingenComponent
} from "./schenking/toelichtingen-tekst/tekst-overige-schenkingen/tekst-overige-schenkingen.component";
import {
    TekstOnroerendeZakenComponent
} from "./schenking/toelichtingen-tekst/tekst-onroerende-zaken/tekst-onroerende-zaken.component";
import {
    TekstOndernemingenComponent
} from "./schenking/toelichtingen-tekst/tekst-ondernemingen/tekst-ondernemingen.component";
import {
    TekstKwijtscheldingenComponent
} from "./schenking/toelichtingen-tekst/tekst-kwijtscheldingen/tekst-kwijtscheldingen.component";
import {TekstEffectenComponent} from "./schenking/toelichtingen-tekst/tekst-effecten/tekst-effecten.component";
import {TekstContantenComponent} from "./schenking/toelichtingen-tekst/tekst-contanten/tekst-contanten.component";
import {
    TekstContactpersoonComponent
} from "./schenking/toelichtingen-tekst/tekst-contactpersoon/tekst-contactpersoon.component";
import {
    TekstConserverendeAanslagComponent
} from "./schenking/toelichtingen-tekst/tekst-conserverende-aanslag/tekst-conserverende-aanslag.component";
import {TekstBorComponent} from "./schenking/toelichtingen-tekst/tekst-bor/tekst-bor.component";
import {TekstBerekeningComponent} from "./schenking/toelichtingen-tekst/tekst-berekening/tekst-berekening.component";
import {TekstBelastingComponent} from "./schenking/toelichtingen-tekst/tekst-belasting/tekst-belasting.component";
import {TekstBegiftigdeComponent} from "./schenking/toelichtingen-tekst/tekst-begiftigde/tekst-begiftigde.component";
import {
    TekstAlgemeneVragenComponent
} from "./schenking/toelichtingen-tekst/tekst-algemene-vragen/tekst-algemene-vragen.component";
import {TekstAkteComponent} from "./schenking/toelichtingen-tekst/tekst-akte/tekst-akte.component";

@NgModule({
  imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule, AangeverComponent, AlgemeneVragenComponent, BelastingComponent, BerekeningComponent, ContactpersoonComponent, ContantenComponent, EffectenComponent, KwijtscheldingenComponent, OndernemingenComponent, OnroerendeZakenComponent, OverigeSchenkingenComponent, RoerendeZakenComponent, SchenkerComponent, SchuldigerkenningenComponent, UitkeringenComponent, VrijstellingenComponent, VruchtgebruikComponent, AkteComponent, ConserverendeAanslagComponent, VoorkomingComponent, BorComponent, SharedUiButtonModule, SharedUiDialogModule, TekstAangeverComponent, TekstSchenkerComponent, TekstSchuldigerkenningenComponent, TekstUitkeringenComponent, TekstVoorkomingComponent, TekstVrijstellingenComponent, TekstVruchtgebruikComponent, TekstRoerendeZakenComponent, TekstOverigeSchenkingenComponent, TekstOnroerendeZakenComponent, TekstOndernemingenComponent, TekstKwijtscheldingenComponent, TekstEffectenComponent, TekstContantenComponent, TekstContactpersoonComponent, TekstConserverendeAanslagComponent, TekstBorComponent, TekstBerekeningComponent, TekstBelastingComponent, TekstBegiftigdeComponent, TekstAlgemeneVragenComponent, TekstAkteComponent, FeatureTaxDonationDetailsComponent],
  declarations: [],
  exports: [FeatureTaxDonationDetailsComponent]

})
export class FeatureTaxDonationDetailsModule {}
